import BaseApi from './BaseApi'

class ConflictDeclarationsApi extends BaseApi {
  get conflictDeclarationsUrl () {
    return 'conflictDeclarations'
  }

  fetchingConflictDeclarations () {
    return this.getJson(this.conflictDeclarationsUrl)
  }
}
export default ConflictDeclarationsApi

